// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__Stjh2 {
  display: flex;
  align-items: center;

  width: 100%;
  padding: 7px 32px 7px 7px;

  text-align: center;
  cursor: pointer;
}

.root__Stjh2:hover {
}

.unavailable__X9X_x {
  opacity: 0.5;
  cursor: not-allowed;
}

.listingImage__M2Moe {
  border-radius: var(--borderRadiusMedium);
  margin-right: 16px;
  width: 56px;
  height: 56px;

  object-fit: cover;
}

.info__CIIHC {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;

  width: 100%;
}

.title__Z57ob {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;

  text-align: left;

  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: var(--fontWeightRegular);
}

.availabilityText__VYA01 {

  font-weight: var(--fontWeightSemiBold);
  color: var(--colorSuccess);
}

.unavailableText__CiRL_ {
  color: var(--colorFail);
}
`, "",{"version":3,"sources":["webpack://./src/components/ListingSelector/ListingItem/ListingItem.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;;EAEnB,WAAW;EACX,yBAAyB;;EAEzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;AACA;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,WAAW;EACX,YAAY;;EAEZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;;EAER,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;;EAErB,gBAAgB;;EAEhB,gBAAgB;EAChB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;;EAGE,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".root {\n  display: flex;\n  align-items: center;\n\n  width: 100%;\n  padding: 7px 32px 7px 7px;\n\n  text-align: center;\n  cursor: pointer;\n}\n\n.root:hover {\n}\n\n.unavailable {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.listingImage {\n  border-radius: var(--borderRadiusMedium);\n  margin-right: 16px;\n  width: 56px;\n  height: 56px;\n\n  object-fit: cover;\n}\n\n.info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n\n  width: 100%;\n}\n\n.title {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n\n  text-align: left;\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: var(--fontWeightRegular);\n}\n\n.availabilityText {\n  composes: textXSmall from global;\n\n  font-weight: var(--fontWeightSemiBold);\n  color: var(--colorSuccess);\n}\n\n.unavailableText {\n  color: var(--colorFail);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__Stjh2`,
	"unavailable": `unavailable__X9X_x`,
	"listingImage": `listingImage__M2Moe`,
	"info": `info__CIIHC`,
	"title": `title__Z57ob`,
	"availabilityText": `availabilityText__VYA01 textXSmall`,
	"unavailableText": `unavailableText__CiRL_`
};
export default ___CSS_LOADER_EXPORT___;
